<template>
    <div v-if="!isLoading" :key="tick">
        <form @submit.prevent="submitTaskTemplate">
                <h6 class="heading-small text-muted mb-4">Allgemeine Angaben</h6>
                <div class="row">
                    <div class="col-lg-6">
                        <base-input alternative=""
                                    required
                                    label="Bezeichnung"
                                    placeholder="z.B. Kontrolle der Informationsmaterialien"
                                    :input-classes="[(errors.includes('Name')) ? 'is-invalid' : '','form-control-alternative']"
                                    v-model="form.type"
                        />
                    </div>
                    <div class="col-lg-2">
                        <label class="form-control-label">
                            Status*</label><br>
                        <switches v-model="form.isActive"
                                  theme="bootstrap"
                                  color="primary"
                                  style="padding-left: 2rem;"
                                  text-enabled="aktiv"
                                  text-disabled="inaktiv"></switches>
                    </div>
                    <div class="col-lg-2">
                        <label class="form-control-label">
                           Öffentlich*</label><br>
                        <switches v-model="form.isPublic"
                                  theme="bootstrap"
                                  color="primary"
                                  style="padding-left: 2rem;"
                                  text-enabled="ja"
                                  text-disabled="nein"></switches>
                    </div>
                    <div class="col-lg-2">
                        <label v-b-tooltip.hover title="Automatische Erledigung der Aufgaben. Funktioniert nur bei geöffnetem Socialguard" class="form-control-label">
                            Auto*</label><br>
                        <switches v-model="form.isAutocomplete"
                                  theme="bootstrap"
                                  color="primary"
                                  style="padding-left: 2rem;"
                                  text-enabled="ja"
                                  text-disabled="nein"></switches>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <textarea v-model="form.description" :class="[(errors.includes('Anweisung')) ? 'is-invalid' : '','form-control form-control-alternative']" id="tastTemplateCommand" rows="3" placeholder="Hier ist Platz für Ihre Anweisungen."></textarea>
                    </div>
                </div>
                <h6 class="heading-small text-muted mb-4" v-if="showUserSelection" >Aufgaben einem Benutzer zuweisen</h6>
                <div class="row" v-if="showUserSelection">
                    <div v-if="type === 'normal'" class="col-lg-3">
                    <label class="form-control-label">
                        Standort
                        <span>*</span></label>
                    <select  v-model="form.location"
                            class="mb-1 custom-select form-control">
                        <option :value="null" selected disabled>Standort auswählen</option>
                        <option v-for="location in $store.getters['location/showLocationCollection']" :key="location.id" :value="location['@id']">{{ location.name }}
                        </option>
                    </select>
                    </div>
                    <div v-if="form.location !== null" class="col-lg-3">
                    <label  class="form-control-label">
                        Benutzer
                        <span>*</span></label>
                    <select v-model="form.user"
                            :class="[(errors.includes('Benutzer')) ? 'is-invalid' : '','mb-1 custom-select form-control']">
                        <option :value="null" selected disabled>Benutzer auswählen</option>
                        <option v-for="user in users" :key="user.id" :value="user['@id']">{{ user.firstname+" "+user.lastname }}
                        </option>
                    </select>
                    </div>
                </div>
                <h6 class="heading-small text-muted mb-4 mt-4">Ausführungszeitpunkte festlegen</h6>
                <div class="row">
                    <div class="col">
                        <cron-editor v-model="form.schedule" locale="de">
                            <p style="margin-left:1rem;margin-bottom: 0.2rem;" v-for="(d,i) in previewList" :key="d+i">
                                {{i+1}}. Lauf: <strong>{{d|formatDate}}</strong>
                            </p>
                        </cron-editor>
                    </div>
                </div>
                <h6 class="heading-small text-muted mb-4 mt-4">Antwortmöglichkeiten festlegen</h6>
                <div :class="[(errors.includes('Antworten') || errors.includes('Standard-Antwort')) ? 'is-invalid' : '','row']">
                    <div class="col-lg-12">
                        <a href="#" @click.prevent="createAnswer()">Antwort hinzufügen</a>
                        <base-table v-if="(form.possibleAnswers)" class="table align-items-center table-flush"
                                    thead-classes="thead-light"
                                    tbody-classes="list"
                                    :data="form.possibleAnswers">
                            <template slot="columns">
                                <th>Antwort</th>
                                <th>Ereignisgesteuerte Maßnahme</th>
                                <th>Standard Antwort</th>
                                <th></th>
                            </template>

                            <template slot-scope="{row}">
                                <th scope="row">
                                    <base-input v-model="row.value" class="mb-1" input-classes="form-control"></base-input>
                                </th>
                                <td>
                                    <select v-model="row.action"
                                            class="mb-1 custom-select form-control">
                                        <option :value="null">keine Spielerschutzmaßnahme durchführen</option>
                                        <option v-for="action in actions" :key="action.id" :value="action.id">({{ action.id }}) {{ action.name }}
                                        </option>
                                    </select>
                                </td>
                                <td v-if="row.value === form.defaultAnswer"><a href="#" @click.prevent="() => {form.defaultAnswer = null; tick++}">Standard-Antwort entfernen</a></td>
                                <td v-else><base-button type="primary" size="sm" @click="() => {form.defaultAnswer = row.value; tick++}">als Standard-Antwort setzen</base-button></td>
                                <td>
                                    <base-button v-on:click="form.possibleAnswers.splice(form.possibleAnswers.indexOf(row.id),1)" icon="fa fa-trash" type="secondary" icon-only
                                                 title="löschen"></base-button>
                                </td>
                            </template>
                        </base-table>
                    </div>
                </div>

            <button class="btn btn-icon my-4 btn-primary" :disabled="isSending">
                <span class="btn-inner--icon"><i v-if="isSending" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                <span class="btn-inner--text">Plan {{(typeof form['@id'] === "undefined") ?  'anlegen' : 'ändern'}}</span></button>
        </form>
    </div>
    <div v-else>loading ...</div>
</template>

<script>


    import CronEditor from "@/components/CronEditor/CronEditor";
    import Switches from "vue-switches";
    export default {
        name:"TaskTemplateForm",
        components:{Switches, CronEditor},
        props: {
            location: {
                default: null
            },
            type: {
                default: 'normal'
            }
        },
        data() {
            return {
                form: {
                    description: null,
                    schedule: '0 8-23/2 * * *',
                    isPublic: false,
                    possibleAnswers: [],
                    location: null,
                    type: '',
                    user: null,
                    isActive: true,
                    isAutocomplete: false,
                    defaultAnswer: null
                },
                preview: [],
                isLoading: true,
                isSending: false,
                tick:1,
                errors:[],
                showUserSelection: true,
            }
        },
        created() {
            this.form.location = this.location;
            let promises = [this.$store.dispatch('actions/getActionCollection')];
            if(!this.$store.getters['location/isReady']) {
                promises.push(this.$store.dispatch('location/getLocationCollection'));
            }



            Promise.all(promises).then(() => {
                this.isLoading = false;
            }).finally(()=> {
                this.isLoading = false;
                let loc = (typeof this.form.location['@id'] === "undefined") ? this.form.location :  this.form.location['@id'];
                if (this.form.location !== null && this.$store.getters['location/showLocationByIRI'](loc).users.length === 1) {
                    this.form.user = this.$store.getters['location/showLocationByIRI'](loc).users[0]['@id'];
                    this.showUserSelection = false;
                }
            })
        },
        watch: {
          cron() {
              this.previewNextRuns();
              //this.tick++;
          }
        },
        computed: {
            cron(){
                return this.form.schedule;
            },
            actions(){
                return (!this.$store.getters['actions/isLoading'] && !this.$store.getters['actions/isEmpty'] && typeof this.locationData().socialconcept  !== "undefined") ? Array.from(this.$store.getters['actions/showActionCollectionByConcept'](this.locationData().socialconcept['@id'])) : [{id: 0, name: 'Kein Sozialkonzept für diesen Standort ausgewählt'}];
            },
            users() {
                return this.locationData().users;
            },
            previewList() {
                return this.preview;
            }
        },
        methods: {
            locationData() {
                let loc = (typeof this.form.location['@id'] === "undefined") ? this.form.location :  this.form.location['@id'];
                return (this.form.location !== null) ? this.$store.getters['location/showLocationByIRI'](loc) : {socialconcept: null, users: []};
            },
            previewNextRuns() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: this.cron
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/tasks/preview`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.preview = response;
                            },
                            error => {
                                reject(error);
                                this.preview = 'error';
                                this.$store.dispatch('alert/error', error)
                            });
                });
            },
            createAnswer() {
                if(this.form.possibleAnswers) {
                    this.form.possibleAnswers.push({value: '', action: null})
                } else {
                    this.form.possibleAnswers = [{value: '', action: null}];
                }
                this.tick++;
            },
            submitTaskTemplate() {
                return new Promise(() => {
                    if(this.form.user !== null
                        && this.form.possibleAnswers.length >  0
                        && this.form.description !== null
                        && ((this.form.isAutocomplete && typeof this.form.defaultAnswer !== 'undefined' && this.form.defaultAnswer !== null) || (!this.form.isAutocomplete))) {
                        let type = (typeof this.form['@id'] === 'undefined') ? 'POST' : 'PATCH';
                        let url = (typeof this.form['@id'] === 'undefined') ? '/api/task_templates' : '/api/task_templates/' + this.form.id;
                        let ctype = (typeof this.form['@id'] === 'undefined') ? 'application/json' : 'application/merge-patch+json';
                        let msg = (typeof this.form['@id'] === 'undefined') ? 'angelegt.' : 'geändert.';
                        const header = this.authHeader();
                        header['Content-Type'] = ctype;
                        let senddata = this.form;
                        const requestOptions = {
                            method:type,
                            headers:header,
                            body:JSON.stringify(senddata)
                        };
                        this.isSending = true;
                        this.tick++;
                        fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                            .then(this.handleResponse)
                            .then(response => {
                                    this.isSending = false;
                                    this.$store.dispatch('alert/success','Aufgabenplan ' + response.description + ' (ID: ' + response.id + ') erfolgreich ' + msg);
                                    this.tick++;
                                    this.$emit('taskTemplateCreated')
                                },
                                error => {
                                    this.isSending = false;
                                    this.$store.dispatch('alert/error',error);

                                    this.tick++;
                                });

                    } else {
                            this.isSending = false;
                            if(this.form.user === null) this.errors.push('Benutzer');
                            if(this.form.possibleAnswers.length === 0) this.errors.push('Antworten');
                            if(this.form.description === null) this.errors.push('Anweisung');
                            if(this.form.type === null) this.errors.push('Name');
                            if(this.form.isAutocomplete && (this.form.defaultAnswer === null || typeof this.form.defaultAnswer === 'undefined')) this.errors.push('Standard-Antwort');

                            this.$store.dispatch('alert/error','Weisen Sie diesem Aufgabenplan '+this.errors.toString()+' zu.');
                            this.tick++;
                    }
                });


            }
        }
    }
</script>

<style scoped>

</style>